import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'

const state = () => ({
  callback: [],
  isLoading: false
})

const getters = {
  callback: (state) => state.callback,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_CALLBACK(state, payload) {
    state.callback = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchCallback({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_CALLBACK', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  deleteSingleCallback(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/callback/delete/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  updateSingleCallback(_context, { id, vm }) {
    axiosWithToken
      .post(`${adminBaseUrl}/callback/update/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
